import { addWeeks, format, startOfDay } from 'date-fns';

export const MAX_WORKSHOP_WEEKS_AHEAD = 6;

export const getMaxWorkshopDate = (from: Date = new Date()) =>
  startOfDay(addWeeks(from, MAX_WORKSHOP_WEEKS_AHEAD));

/**
 * Dates past the beta scheduling window stay selectable so we can track the
 * attempt, but they can't be saved to a workshop.
 */
export const isRestrictedWorkshopDate = (date: Date, from: Date = new Date()) =>
  startOfDay(date) > getMaxWorkshopDate(from);

export const formatMaxWorkshopDate = (from: Date = new Date()) =>
  format(getMaxWorkshopDate(from), 'MMMM d, yyyy');

export const DEFAULT_WORKSHOP_NAME = 'Budgeting Basics';

export const DEFAULT_START_TIME = '18:00:00';

export const TIME_PARSE_REFERENCE = new Date(2000, 0, 1);
